"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonMediaTeaser = void 0;
const React = require("react");
const bronson_react_1 = require("@vwfs-bronson/bronson-react");
const BronsonMediaTeaser = (props) => {
    return (React.createElement(bronson_react_1.MediaTeaser, { reversed: props.reversed, "data-component": 'dh-bronson-media-teaser', imgProps: {
            srcSet: props.img.srcSet,
            src: props.img.src,
            sizes: '100vw',
            alt: props.img.alt,
        }, pretitle: props.pretitle, title: props.title, buttonLabel: props.btnText, buttonModifier: 'c-btn--secondary', buttonProps: {
            'data-component': 'dh-bronson-media-teaser-button',
        }, onButtonClick: () => props.onClick() }, props.text.map((text, index) => {
        return React.createElement("p", { key: index }, text);
    })));
};
exports.BronsonMediaTeaser = BronsonMediaTeaser;
